// Copyright (c) 2016 Deere & Company

import PipProduct, {getDefaultState} from '../state/pip-product';
import actions from '../../actions-list';

const updatePipProduct = (state, action) =>
    PipProduct.update(state, {
        $set: action.data
    });

export default (state = getDefaultState(), action) => {

    const actionTypes = {
        [actions.READ_PIP_PRODUCT_SUCCESS]: updatePipProduct,
        [actions.RESET_PIP_CODE_REQUEST_PIP_PRODUCT]: updatePipProduct
    };

    const reducer = actionTypes[action.type];

    return reducer ?
        reducer(state, action) :
        state;

};



// WEBPACK FOOTER //
// ./src/pip/pip-code/reducers/pip-product.js